/** 当前环境 */
export const serverType: 'test' | 'online' = 'online';